import React, { useRef, useState } from "react";
import GlfLoader from "./GltfLoader";

import { useFrame } from "@react-three/fiber";

import * as THREE from "three";

//use gasp for animation lib..

function Collectible({ position, onCollect, rotation, scale, tint }) {
  const meshRef = useRef();
  // const [clickCount, setClickCount] = useState(0);
  const [lastClickTime, setLastClickTime] = useState(0);
  const [clicked, setClicked] = useState(false);

  const [isActive, setIsActive] = useState(false);
  const timerRef = useRef();

  const [scaleUp, setScaleUp] = useState(true); // State to control scaling

  //play clap audio
  // const audioRef = useRef();

  // Create audio listener
  const listener = new THREE.AudioListener();

  // Create audio source
  const audioLoader = new THREE.AudioLoader();
  const audio = new THREE.Audio(listener);

  // Load audio file
  audioLoader.load(
    process.env.PUBLIC_URL + "/audio/clap_1.mp3",
    function (buffer) {
      audio.setBuffer(buffer);
      audio.setVolume(0.5); // Set audio volume
    }
  );

  // Function to play audio once
  const playAudioOnce = () => {
    audio.play();
  };
  //

  //random rot

  useFrame(() => {
    // Move the mesh up in the Z-axis
    if (isActive && meshRef.current) {
      meshRef.current.position.y += 2;

      //sacle

      const scalemesh = meshRef.current.scale;

      if (scaleUp) {
        const scaleFactor = scalemesh.x + 0.1;
        meshRef.current.scale.set(scaleFactor, scaleFactor, scaleFactor);
      } else {
        meshRef.current.scale.set(0, 0, 0); // Reset scale to 1
      }
    }
  });

  //hidden log event
  const hiddenConsole = {
    log: () => {},
  };

  //click event
  const handleClick = () => {
    if (!clicked) {
      //play audio??
      playAudioOnce();

      setClicked(true);

      // if (timeDiff < doubleClickThreshold) {
      onCollect();

      //put mesh animation in here when clicked!!
      setIsActive(true);

      // Start timer to control scaling
      if (!isActive) {
        timerRef.current = setInterval(() => {
          setScaleUp((prevScaleUp) => !prevScaleUp); // Toggle scaleUp state
          setIsActive(false);
        }, 10000); // Adjust the duration as needed (1 second in this example)
      } else {
        clearInterval(timerRef.current); // Clear the timer if animation is stopped
      }
    }
  };

  // Convert Euler angles to radians
  const maxRotationXRad = rotation[0] * (Math.PI / 180);
  const maxRotationYRad = rotation[1] * (Math.PI / 180);
  const maxRotationZRad = rotation[2] * (Math.PI / 180);

  const maxRotation = [maxRotationXRad, maxRotationYRad, maxRotationZRad];

  return (
    <group
      position={position}
      ref={meshRef}
      // onClick={handleClick}
      scale={scale}
      rotation={maxRotation}
    >
      {/* Visual representation of the collectible */}
      {/* swap with gltf model */}
      <mesh>
        {/* <GlfLoader MeshPath={"./Geo/bear.glb"} col={"#E7D7B3"}/> */}
        <GlfLoader MeshPath={process.env.PUBLIC_URL + "/Geo/bear.glb"} />
      </mesh>

      <mesh
        // click volume for mesh
        onClick={handleClick}
        position={[0, 1.7, 0]}
      >
        <boxGeometry args={[6, 6, 6]} />
        <meshBasicMaterial color={"red"} transparent opacity={0} />
      </mesh>

      {/* <boxGeometry args={[10, 10, 10]} />
      <meshStandardMaterial color="blue" /> */}
    </group>
  );
}

export default Collectible;
